// const Footer = () => {
//     return (
//       <footer style={{ textAlign: 'center', padding: '1rem', background: '#333', color: '#fff' }}>
//         © {new Date().getFullYear()} PaintPro. All rights reserved.
//       </footer>
//     );
//   };
  
//   export default Footer;
  

import React from 'react';
// import { FaInstagram, FaFacebook, FaPhoneAlt, FaEnvelope, FaWhatsapp } from 'react-icons/fa';
import { FaPhoneAlt, FaEnvelope  } from 'react-icons/fa';

import SocialIcons from './Socialicons';
// import { hover } from '@testing-library/user-event/dist/hover';
const Footer = () => {
  return (
    <footer style={styles.footer}>
      {/* Top Section */}
      <div style={styles.topSection}>
        {/* About */}
        <div style={styles.column}>
          <h3 style={styles.heading}>Javed & Sons</h3>
          <p style={styles.text}>
            Expert in Industrial, Residential & Specialized Surface Painting. Reliable. Professional. Experienced.
          </p>
        </div>

        {/* Quick Links */}
        <div style={styles.column}>
          <h4 style={styles.subheading}>Quick Links</h4>
          <ul style={styles.list}>
            <li><a href="/" style={styles.link}>Home</a></li>
            <li><a href="/services" style={styles.link}>Services</a></li>
            <li><a href="/gallery" style={styles.link}>Gallery</a></li>
            <li><a href="/contact" style={styles.link}>Contact</a></li>
          </ul>
        </div>
 <div style={styles.column}>
          <h4 style={styles.subheading}>Services</h4>
          <ul style={styles.list}>
            <li><a href="/services/interior" style={styles.link}>Interior</a></li>
            <li><a href="/services/ceiling" style={styles.link}>Ceiling </a></li>
            <li><a href="/services/exterior" style={styles.link}>Exterior</a></li>
            <li><a href="/services/marquee" style={styles.link}>Marquee</a></li>
            <li><a href="/services/flour" style={styles.link}>Flooring</a></li>
            <li><a href="/services/games" style={styles.link}>Games Area</a></li>
          </ul>
        </div>
        {/* Contact */}
        <div style={styles.column}>
          <h4 style={styles.subheading}>Contact</h4>
          <p style={styles.text}><FaPhoneAlt /> +92 300 7665370</p>
          <p style={styles.text}><FaEnvelope /> info@jscontracts44@gmail.com</p>
          <div style={styles.socialIcons}>
            {/* <a href="https://www.instagram.com/jascontracts44?igsh=eDhyZ2hiNnI2ZjJz" target="_blank" rel="noreferrer" ><FaInstagram stroke='#046565ff' fill='#008080' /></a>
            <a href="https://www.facebook.com/profile.php?id=100067043465199" target="_blank" rel="noreferrer"><FaFacebook stroke='#046565ff' fill='#008080'/></a>
            <a href="https://api.whatsapp.com/send?phone=%2B923007665370&context=AfdZtdEkAYqN2F4mgDQZzfMcSDgGd2Wdk3uduq1UT6Cg2Q3Tyo8XjM_c7Qyy2V7y-bKU0ig4khHGGpAINPHARDa0dgGaCk-qxEpBCmvVGGaCf-Kgu_MFY4TavjWg_MBW6ykO6aB2EE1-0v1yWj6pWw6yVg&source=FB_Page&app=facebook&entry_point=page_cta&fbclid=IwY2xjawMaMAJleHRuA2FlbQIxMABicmlkETFWb0gwVDQ2NXhPdGdITDFWAR6CpiSiJ4ejWS4HG49Xlo88vmwopw54FERhN1nWVA-uJGZ2DM_F7-yixZi8jw_aem_v73NFdFaex2iYBVhq5HzLw" aria-label="whatsapp"><FaWhatsapp stroke='#046565ff' fill='#008080'/></a> */}
          <SocialIcons/>
          </div>
        </div>
      </div>

      {/* Bottom */}
      <div style={styles.bottom}>
        <p style={styles.copyText}>© {new Date().getFullYear()} JAS CONTRACTS. All rights reserved.</p>
      </div>
    </footer>
  );
};

const styles = {
  footer: {
    backgroundColor: '#1a1a1a',
    color: '#fff',
    paddingTop: '40px',
    paddingBottom: '20px',
    paddingLeft: '10%',
    paddingRight: '10%',
    fontFamily: 'Arial, sans-serif',
  },
  topSection: {
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: '30px',
  },
  column: {
    flex: '1 1 250px',
  },
  heading: {
    fontSize: '1.5rem',
    marginBottom: '10px',
    color: '#008080',
  },
  subheading: {
    fontSize: '1.2rem',
    marginBottom: '10px',
    color: '#fff',
  },
  text: {
    fontSize: '0.95rem',
    marginBottom: '8px',
  },
  list: {
    listStyle: 'none',
    padding: 0,
  },
  link: {
    color: '#aaa',
    textDecoration: 'none',
    display: 'block',
    marginBottom: '5px',
  },
  socialIcons: {
    display: 'flex',
    gap: '10px',
    marginTop: '10px',
    // color:'#008080',
    
    fontSize: '1.2rem',
  },
  bottom: {
    marginTop: '30px',
    textAlign: 'center',
    borderTop: '1px solid #444',
    paddingTop: '15px',
  },
  copyText: {
    fontSize: '0.85rem',
    color: '#aaa',
  },
};

export default Footer;
